import React, { useState } from "react";
import { Space } from "antd";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import "@/plugins/desc.less";
import {
  Input,
  Slider,
  ConfigTitle,
  InputNumber,
  Select,
  BaseButton,
  ColorPicker,
  Selector,
} from "@/components";
import { InputNumber3x, Slider3x, InputWithImg, HotArea } from "@/HOC";

export default function Desc({
  currentPlugin,
  changeCurrentPluginRect,
  updateCurrentPluginProps,
  deleteInsertPlugin,
}) {
  const { props, rectOptions, extension } = currentPlugin;
  const { intervalDuration, slideWidthDuration, bannersGroupStruct } =
    extension;
  const { banners } = props;
  //   const curBanner = props.banners[currentIndex];
  const subProps1 = props.subProps[0];
  const subProps2 = props.subProps[1];
  const subProps3 = props.subProps[2];

  const subRectOptions1 = rectOptions.subRectOptions[0];
  const subRectOptions2 = rectOptions.subRectOptions[1];
  const subRectOptions3 = rectOptions.subRectOptions[2];
  const hotAreaRectOptions = rectOptions.subRectOptions[3];
  return (
    <div className="desc-wrap">
      <ConfigTitle
        style={{
          padding: "20px 0 5px 20px",
        }}
        title="特殊滑动"
        detail="固定水平排列，每次滑动切换一帧"
      />
      <div className="desc-board">
        <Space direction="vertical" size={10}>
          <ConfigTitle
            title="滑动素材设置"
            detail="每组下面支持添加多帧素材"
            style={{
              height: 37,
            }}
            titleSize={14}
            detailSize={12}
          />
          <Selector
            list={banners}
            deleteButtonText="删除本组"
            addFrameText="添加一组"
            onClickAdd={() => {
              const newBanners = _.cloneDeep(banners);
              newBanners.push(bannersGroupStruct);
              updateCurrentPluginProps({
                banners: newBanners,
              });
            }}
            onClickDelete={(deleteIndex) => {
              if (banners.length === 1) return;
              const newBanners = _.cloneDeep(banners);
              newBanners.splice(deleteIndex, 1);
              updateCurrentPluginProps({
                banners: newBanners,
              });
            }}
            content={(currentBannerGroup, currentBannerGroupIndex) => {
              return (
                <>
                  <ConfigTitle
                    title={`第${currentBannerGroupIndex + 1}组`}
                    detail="配置当前一组素材的设置"
                    style={{
                      height: 37,
                    }}
                    titleSize={14}
                    detailSize={12}
                  />
                  <Selector
                    list={currentBannerGroup}
                    deleteButtonText="删除本帧"
                    addFrameText="添加一帧"
                    selectTitles={currentBannerGroup.map(
                      (_, idx) => `第${idx + 1}帧`,
                    )}
                    onClickAdd={() => {
                      const newBanners = _.cloneDeep(banners);
                      newBanners[currentBannerGroupIndex].push(
                        bannersGroupStruct[0],
                      );
                      updateCurrentPluginProps({
                        banners: newBanners,
                      });
                    }}
                    onClickDelete={(deleteIndex) => {
                      if (currentBannerGroup.length === 1) return;
                      const newBanners = _.cloneDeep(banners);
                      newBanners[currentBannerGroupIndex].splice(
                        deleteIndex,
                        1,
                      );
                      updateCurrentPluginProps({
                        banners: newBanners,
                      });
                    }}
                    content={(currentBanner, currentBannerIndex) => {
                      return (
                        <>
                          <ConfigTitle
                            title={`第${currentBannerIndex + 1}帧`}
                            detail="配置当前一帧素材的设置"
                            style={{
                              height: 37,
                            }}
                            titleSize={14}
                            detailSize={12}
                          />
                          <InputWithImg
                            labelContent="图片链接"
                            defaultValue={currentBanner.imageUrl}
                            onChange={(e) => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[currentBannerGroupIndex][
                                currentBannerIndex
                              ].imageUrl = e;
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                          />
                          <Input
                            labelContent="跳转链接"
                            defaultValue={currentBanner.jumpUrl}
                            onChange={(e) => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[currentBannerGroupIndex][
                                currentBannerIndex
                              ].jumpUrl = e;
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                          />
                          <InputWithImg
                            labelContent="热区图链接"
                            defaultValue={currentBanner.hotImageUrl}
                            onChange={(e) => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[currentBannerGroupIndex][
                                currentBannerIndex
                              ].hotImageUrl = e;
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                          />
                          <HotArea
                            editContentSize={{
                              width: hotAreaRectOptions.width,
                              height: hotAreaRectOptions.height,
                            }}
                            contentFit="fill"
                            defaultValue={currentBanner.hotArea}
                            editContent={currentBanner.hotImageUrl}
                            onSave={(data) => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[currentBannerGroupIndex][
                                currentBannerIndex
                              ].hotArea = data;
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                            showCopyBtn={currentBannerIndex !== 0}
                            onCopy={() => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[currentBannerGroupIndex][
                                currentBannerIndex
                              ].hotArea = _.cloneDeep(
                                currentBannerGroup[0].hotArea,
                                {},
                              );
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                          />
                        </>
                      );
                    }}
                  />
                </>
              );
            }}
          />
        </Space>
      </div>
      <div className="desc-board">
        <Space direction="vertical" size={10} align="start">
          <ConfigTitle
            title="滑动区域设置"
            style={{
              height: 21,
            }}
            titleSize={14}
            detailSize={0}
          />

          <Space size={10}>
            <InputNumber3x
              labelContent="上边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                rectOptions.top = val;
                changeCurrentPluginRect(rectOptions);
              }}
              defaultValue={rectOptions.top}
            />
            <InputNumber3x
              labelContent="左边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                rectOptions.left = val;
                changeCurrentPluginRect(rectOptions);
              }}
              defaultValue={rectOptions.left}
            />
          </Space>
          <Space size={10}>
            <InputNumber3x
              labelContent="高"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                props.imgHeight = val;
                updateCurrentPluginProps(props);
              }}
              defaultValue={props.imgHeight}
            />
          </Space>
          <Slider3x
            title="滑动宽度"
            suffix="px"
            defaultValue={props.slideWidth}
            max={slideWidthDuration[1]}
            min={slideWidthDuration[0]}
            onChange={(v) => {
              updateCurrentPluginProps({
                slideWidth: v,
              });
            }}
          />
          <Slider
            title="展示时间"
            suffix="秒"
            defaultValue={props.interval}
            max={intervalDuration[1]}
            min={intervalDuration[0]}
            onChange={(v) => {
              updateCurrentPluginProps({
                interval: v,
              });
            }}
          />
          <ConfigTitle
            title="激活帧设置"
            style={{
              height: 21,
            }}
            titleSize={14}
            detailSize={0}
          />
          <Space size={10}>
            <InputNumber3x
              labelContent="宽"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions1.width = val;
                changeCurrentPluginRect(subRectOptions1, 1);
              }}
              defaultValue={subRectOptions1.width}
            />
            <InputNumber3x
              labelContent="高"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions1.height = val;
                changeCurrentPluginRect(subRectOptions1, 1);
              }}
              defaultValue={subRectOptions1.height}
            />
          </Space>
          <Space size={10}>
            <InputNumber3x
              labelContent="上边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions1.top = val;
                changeCurrentPluginRect(subRectOptions1, 1);
              }}
              defaultValue={subRectOptions1.top}
            />
            <InputNumber3x
              labelContent="左边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions1.left = val;
                changeCurrentPluginRect(subRectOptions1, 1);
              }}
              defaultValue={subRectOptions1.left}
            />
          </Space>
          <Space direction="vertical" align="start">
            <span style={{ fontSize: 12, color: "#999" }}>当前帧透明度:</span>
            <InputNumber
              labelContent=""
              size="middle"
              step={0.1}
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subProps1.opacity = val;
                updateCurrentPluginProps(subProps1, 1);
              }}
              defaultValue={subProps1.opacity}
            />
          </Space>
          <ConfigTitle
            title="未激活帧1设置"
            style={{
              height: 21,
            }}
            titleSize={14}
            detailSize={0}
          />
          <Space size={10}>
            <InputNumber3x
              labelContent="宽"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions2.width = val;
                changeCurrentPluginRect(subRectOptions2, 2);
              }}
              defaultValue={subRectOptions2.width}
            />
            <InputNumber3x
              labelContent="高"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions2.height = val;
                changeCurrentPluginRect(subRectOptions2, 2);
              }}
              defaultValue={subRectOptions2.height}
            />
          </Space>
          <Space size={10}>
            <InputNumber3x
              labelContent="上边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions2.top = val;
                changeCurrentPluginRect(subRectOptions2, 2);
              }}
              defaultValue={subRectOptions2.top}
            />
            <InputNumber3x
              labelContent="左边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions2.left = val;
                changeCurrentPluginRect(subRectOptions2, 2);
              }}
              defaultValue={subRectOptions2.left}
            />
          </Space>
          <Space direction="vertical" align="start">
            <span style={{ fontSize: 12, color: "#999" }}>当前帧透明度:</span>
            <InputNumber
              labelContent=""
              size="middle"
              step={0.1}
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subProps2.opacity = val;
                updateCurrentPluginProps(subProps2, 2);
              }}
              defaultValue={subProps2.opacity}
            />
          </Space>
          <ConfigTitle
            title="未激活帧2设置"
            style={{
              height: 21,
            }}
            titleSize={14}
            detailSize={0}
          />
          <Space size={10}>
            <InputNumber3x
              labelContent="宽"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions3.width = val;
                changeCurrentPluginRect(subRectOptions3, 3);
              }}
              defaultValue={subRectOptions3.width}
            />
            <InputNumber3x
              labelContent="高"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions3.height = val;
                changeCurrentPluginRect(subRectOptions3, 3);
              }}
              defaultValue={subRectOptions3.height}
            />
          </Space>
          <Space size={10}>
            <InputNumber3x
              labelContent="上边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions3.top = val;
                changeCurrentPluginRect(subRectOptions3, 3);
              }}
              defaultValue={subRectOptions3.top}
            />
            <InputNumber3x
              labelContent="左边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subRectOptions3.left = val;
                changeCurrentPluginRect(subRectOptions3, 3);
              }}
              defaultValue={subRectOptions3.left}
            />
          </Space>
          <Space direction="vertical" align="start">
            <span style={{ fontSize: 12, color: "#999" }}>当前帧透明度:</span>
            <InputNumber
              labelContent=""
              size="middle"
              step={0.1}
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                subProps3.opacity = val;
                updateCurrentPluginProps(subProps3, 3);
              }}
              defaultValue={subProps3.opacity}
            />
          </Space>
        </Space>
      </div>
      <div className="desc-board">
        <Space direction="vertical" size={10} align="start">
          <ConfigTitle
            title="热区图位置"
            style={{
              height: 37,
            }}
            detail="滑动素材中热区图的大小和位置"
            titleSize={14}
          />
          <Space size={10}>
            <InputNumber3x
              labelContent="宽"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                hotAreaRectOptions.width = val;
                changeCurrentPluginRect(hotAreaRectOptions, 3);
              }}
              defaultValue={hotAreaRectOptions.width}
            />
            <InputNumber3x
              labelContent="高"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                hotAreaRectOptions.height = val;
                changeCurrentPluginRect(hotAreaRectOptions, 3);
              }}
              defaultValue={hotAreaRectOptions.height}
            />
          </Space>
          <Space size={10}>
            <InputNumber3x
              labelContent="上边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                hotAreaRectOptions.top = val;
                changeCurrentPluginRect(hotAreaRectOptions, 3);
              }}
              defaultValue={hotAreaRectOptions.top}
            />
            <InputNumber3x
              labelContent="左边距"
              size="middle"
              style={{
                color: "#696969",
              }}
              onChange={(val) => {
                hotAreaRectOptions.left = val;
                changeCurrentPluginRect(hotAreaRectOptions, 3);
              }}
              defaultValue={hotAreaRectOptions.left}
            />
          </Space>
        </Space>
      </div>
    </div>
  );
}
